import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { PureComponent } from '../component';
import DatumTree from '../Datum/Tree';
import Root from './Root';
import { deepClone } from '../utils/clone';
var DefaultProps = {
  data: [],
  defaultExpanded: [],
  defaultValue: [],
  mode: 0,
  dataUpdate: true,
  childrenKey: 'children',
  dragImageStyle: {}
};

var Tree =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tree, _PureComponent);

  var _super = _createSuper2(Tree);

  function Tree(props) {
    var _this;

    _classCallCheck(this, Tree);

    _this = _super.call(this, props);
    _this.handleDragImageSelector = void 0;
    _this.handleClidrenClass = void 0;
    _this.handleLeafClass = void 0;
    _this.nodes = void 0;
    _this.datum = void 0;
    _this.state = {
      active: null
    };
    _this.nodes = new Map();
    _this.datum = props.datum || new DatumTree({
      data: props.data,
      loader: props.loader,
      keygen: props.keygen,
      mode: props.mode,
      onChange: props.onChange,
      value: props.value || props.defaultValue,
      disabled: typeof props.disabled === 'function' ? props.disabled : undefined,
      childrenKey: props.childrenKey || DefaultProps.childrenKey,
      unmatch: props.unmatch
    });
    _this.handleDrop = _this.handleDrop.bind(_assertThisInitialized(_this));
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
    _this.handleNodeClick = _this.handleNodeClick.bind(_assertThisInitialized(_this));
    _this.bindNode = _this.bindNode.bind(_assertThisInitialized(_this));
    _this.getNodeInitState = _this.getNodeInitState.bind(_assertThisInitialized(_this));
    _this.unbindNode = _this.unbindNode.bind(_assertThisInitialized(_this));
    _this.handleDragImageSelector = _this.handleProps.bind(_assertThisInitialized(_this), 'dragImageSelector');
    _this.handleClidrenClass = _this.handleProps.bind(_assertThisInitialized(_this), 'childrenClass');
    _this.handleLeafClass = _this.handleProps.bind(_assertThisInitialized(_this), 'leafClass');

    _this.bindDatum();

    return _this;
  }

  _createClass(Tree, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.expanded !== this.props.expanded) {
        this.handleExpanded(this.props.expanded);
      }

      if (prevProps.active !== this.props.active) {
        this.handleActive(this.props.active);
      }

      if (this.props.onChange || this.props.onDrop || this.props.radioUpdate) {
        this.datum.mode = this.props.mode;
        if (prevProps.value !== this.props.value) this.datum.setValue(this.props.value || []);
        if (prevProps.data !== this.props.data && this.props.dataUpdate) this.datum.setData(this.props.data);
      }
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var active = this.props.active;
      return active === undefined ? this.state.active : active;
    }
  }, {
    key: "getNodeInitState",
    value: function getNodeInitState(id) {
      var active = this.props.active === id;
      var expanded = this.props.expanded || this.props.defaultExpanded;

      if (this.props.defaultExpandAll) {
        return {
          active: active,
          expanded: true
        };
      }

      return {
        active: active,
        expanded: !!(expanded && expanded.indexOf(id) >= 0)
      };
    }
  }, {
    key: "bindDatum",
    value: function bindDatum() {
      var bindDatum = this.props.bindDatum;
      if (bindDatum) bindDatum(this.datum);
    }
  }, {
    key: "bindNode",
    value: function bindNode(id, update) {
      /*
      if (this.nodes.has(id)) {
        console.error(`Node with '${id}' key has already been added. Tree node's key must be unique.`)
        return {}
      }
      */
      this.nodes.set(id, update);
    }
  }, {
    key: "unbindNode",
    value: function unbindNode(id) {
      this.nodes["delete"](id);
    }
  }, {
    key: "handleExpanded",
    value: function handleExpanded(expanded) {
      var temp = new Set(expanded);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              id = _step$value[0],
              update = _step$value[1];

          update('expanded', temp.has(id));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "handleActive",
    value: function handleActive(active) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.nodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              id = _step2$value[0],
              update = _step2$value[1];

          update('active', id === active);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "handleNodeClick",
    value: function handleNodeClick(node, id) {
      var _this2 = this;

      var _this$props = this.props,
          active = _this$props.active,
          onClick = _this$props.onClick;

      if (active === undefined) {
        this.setState({
          active: id
        }, function () {
          _this2.handleActive(id);
        });
      }

      if (onClick) {
        onClick(node, id, this.datum.getPath(id));
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(id) {
      var _this$props2 = this.props,
          expanded = _this$props2.expanded,
          onExpand = _this$props2.onExpand;
      var newExpanded;

      if (!expanded && onExpand) {
        onExpand([id]);
        return;
      }

      var expandedArr = expanded;

      if (expandedArr.indexOf(id) >= 0) {
        newExpanded = expandedArr.filter(function (e) {
          return e !== id;
        });
      } else {
        newExpanded = [].concat(_toConsumableArray(expandedArr), [id]);
      }

      if (onExpand) onExpand(newExpanded);
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(id, targetId, position) {
      var _this3 = this;

      var childrenKey = this.props.childrenKey;
      var current = this.datum.getPath(id);
      var target = this.datum.getPath(targetId);
      if (!current || !target) return;
      var cloneData = deepClone(this.props.data);
      var data = immer(cloneData, function (draft) {
        var node = draft;
        var temp;

        var removeNode = function removeNode() {};

        var offset = 0;
        current.indexPath.forEach(function (p, i) {
          if (i < current.indexPath.length - 1) {
            node = node[p][childrenKey];
          } else {
            temp = node;

            removeNode = function removeNode() {
              return temp.splice(p, 1)[0];
            };

            node = node[p];
          }
        });
        var tnode = draft;
        target.indexPath.forEach(function (p, i) {
          if (i < target.indexPath.length - 1) {
            tnode = tnode[p][childrenKey];
          } else if (tnode === temp) {
            // same parent
            removeNode();

            if (current.index <= target.index) {
              offset = -1;
            }

            removeNode = function removeNode() {};
          }
        });

        if (position === -1) {
          tnode = tnode[target.index + offset];
          if (!Array.isArray(tnode[childrenKey])) tnode[childrenKey] = [];
          tnode[childrenKey].push(node);
          position = tnode[childrenKey].length - 1;

          var update = _this3.nodes.get(targetId);

          if (update) update('expanded', true);
        } else {
          tnode.splice(position + offset, 0, node);
          targetId = target.path[target.path.length - 1];
        }

        removeNode();
      });

      if (this.props.onDrop) {
        this.props.onDrop(data, id, targetId, position);
      }
    }
  }, {
    key: "handleProps",
    value: function handleProps(key) {
      return this.props[key];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          style = _this$props3.style,
          data = _this$props3.data,
          disabled = _this$props3.disabled,
          line = _this$props3.line,
          keygen = _this$props3.keygen,
          onExpand = _this$props3.onExpand,
          onChange = _this$props3.onChange,
          renderItem = _this$props3.renderItem,
          _this$props3$mode = _this$props3.mode,
          mode = _this$props3$mode === void 0 ? DefaultProps.mode : _this$props3$mode,
          onDrop = _this$props3.onDrop,
          loader = _this$props3.loader,
          parentClickExpand = _this$props3.parentClickExpand,
          childrenKey = _this$props3.childrenKey,
          expandIcons = _this$props3.expandIcons,
          _this$props3$dragImag = _this$props3.dragImageStyle,
          dragImageStyle = _this$props3$dragImag === void 0 ? DefaultProps.dragImageStyle : _this$props3$dragImag,
          dragImageSelector = _this$props3.dragImageSelector,
          childrenClass = _this$props3.childrenClass,
          leafClass = _this$props3.leafClass,
          dragHoverExpand = _this$props3.dragHoverExpand,
          doubleClickExpand = _this$props3.doubleClickExpand,
          iconClass = _this$props3.iconClass,
          nodeClass = _this$props3.nodeClass,
          dragSibling = _this$props3.dragSibling;
      var onToggle = onExpand ? this.handleToggle : undefined;
      return (
        /*#__PURE__*/
        React.createElement(Root, {
          className: className,
          data: data,
          datum: this.datum,
          disabled: typeof disabled !== 'function' && !!disabled,
          bindNode: this.bindNode,
          getNodeInitState: this.getNodeInitState,
          keygen: keygen,
          line: line,
          loader: loader,
          mode: mode,
          unbindNode: this.unbindNode,
          onChange: onChange,
          onDrop: onDrop && this.handleDrop,
          onToggle: onToggle,
          onNodeClick: this.handleNodeClick,
          renderItem: renderItem,
          style: style,
          parentClickExpand: parentClickExpand,
          childrenKey: childrenKey,
          expandIcons: expandIcons,
          dragImageStyle: dragImageStyle,
          dragImageSelector: typeof dragImageSelector === 'function' ? dragImageSelector : this.handleDragImageSelector,
          childrenClass: typeof childrenClass === 'function' ? childrenClass : this.handleClidrenClass,
          leafClass: typeof leafClass === 'function' ? leafClass : this.handleLeafClass,
          dragHoverExpand: dragHoverExpand,
          doubleClickExpand: doubleClickExpand,
          iconClass: iconClass,
          nodeClass: nodeClass,
          dragSibling: dragSibling
        })
      );
    }
  }]);

  return Tree;
}(PureComponent);

Tree.defaultProps = DefaultProps;
export default Tree;